import { render, staticRenderFns } from "./AltaDeAvl.vue?vue&type=template&id=49397c2a&scoped=true"
import script from "./AltaDeAvl.vue?vue&type=script&lang=js"
export * from "./AltaDeAvl.vue?vue&type=script&lang=js"
import style0 from "./AltaDeAvl.vue?vue&type=style&index=0&id=49397c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49397c2a",
  null
  
)

export default component.exports